import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { RenderEditOptions } from "components/MainSectionTemplate/types";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";

interface ProductGroupDetailSectionProps {
  productGroup: server.dto.ProductGroup;
}

export const ProductGroupDetailSection = (props: ProductGroupDetailSectionProps) => {
  const [productGroup, setProductGroup] = useState<server.dto.ProductGroup>(props.productGroup);

  const onValueChanged = (key: string, value: any) => {
    if (key === "title") {
      setProductGroup({ ...productGroup, title: value });
    }
  }

  return <DetailSectionTemplate
    isInPageEditable
    onValueChanged={onValueChanged}
    sections={[{
      type: "regular",
      key: "productGroup",
      title: RESX.ProductGroup.resxProductGroup,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        render: () => <div>{productGroup.title}</div>,
        inPageEdit: {
          render: ({ value, onChange, submit, cancel }: RenderEditOptions<string>) => <RequiredTextInput
            validatorKey="title"
            focusOnMount
            maxLength={serverReference.constants.productGroup.maxTitleLength}
            value={value}
            onChange={(title) => { onChange(title); }}
            onEnter={() => submit()}
            onEsc={() => cancel()} />,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: productGroup.title,
          submitChange: (title: string) => window.CoreApi.ProductGroup.Update({
            productGroupId: productGroup.productGroupId,
            title: title,
          }),
        }
      }]
    }]}
  />
}